module.exports = __webpack_public_path__ + "img/icon-card-3.456549a4.webp";